
import { createSlice } from '@reduxjs/toolkit';

export const profileSlice = createSlice({
  name: 'profile',
  initialState: {
    profileValues: {},
    graphToken : "",
    teamsToken : "",
    msDomain : "",
    sbcDetails : {},
    txtFileDetails : {
      "company_name": "",
      "domainName": "",
      "status": "",
      "company_id": "",
      "domainId": "",
      "emailId": "",
      "sbc_fqdn": "",
      "port": 5061,
      "txtjson": {
          "ttl": "",
          "txtName": "",
          "txtValue": ""
      },
      "isdnsverified": null,
      "openport": null,
      "enablepublicrouting": null,
      "createdAt":""
  },
  },
  reducers: {
   setProfileValues: (state, action) => {
      state.profileValues = action.payload;
    }, 
    setTeamsToken: (state, action) => {
      state.teamsToken = action.payload;
    }, 
    setGraphToken: (state, action) => {
      state.graphToken = action.payload;
    },
    setMsDomain : (state, action) => {
      state.msDomain = action.payload;
    },
    setSbcDetails : (state, action) => {
      state.sbcDetails = action.payload;
    },
    setTxtFileDetails : (state, action) => {
      state.txtFileDetails = action.payload;
    },
    resetTxtFileDetails : (state) => {
      state.txtFileDetails = {
        "company_name": "",
        "domainName": "",
        "status": "",
        "company_id": "",
        "domainId": "",
        "emailId": "",
        "sbc_fqdn": "",
        "port": 5061,
        "txtjson": {
            "ttl": "",
            "txtName": "",
            "txtValue": ""
        },
        "isdnsverified": null,
        "openport": null,
        "enablepublicrouting": null,
        "createdAt":""
    }
    }
  }
});

export const {
  setProfileValues,
  setTeamsToken,
  setGraphToken,
  setMsDomain,
  setSbcDetails,
  setTxtFileDetails,
  resetTxtFileDetails,
} = profileSlice.actions

export default profileSlice.reducer;
